import React from "react";
import styles from "./SectionTitle.module.scss";


const SectionTitle: React.FC<{ text: string }> = ({text}) => {
    return (
        <h2 className={styles.sectionTitle}>{text}</h2>
    )
}

export default SectionTitle;